import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { submitLogin } from '../../api/login';
import { ApiContext } from '../../contexts/ApiContext';
import { AuthContext } from '../../contexts/AuthContext';
import { mainishStyles } from '../../styling';
import {
  loginSuccMessage,
  submitMessage,
  tokenNotFoundMessage,
} from '../../utils/constant';
import { InputField } from '../Common/Form';
import { useSnackBar } from '../Common/SnackBarContext';
import { loginData } from './loginFieldData';

export default function LoginForm() {
  const formclasses = mainishStyles();
  const { handleSubmit, errors, register } = useForm();
  const apiContext = useContext(ApiContext);
  const authContext = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const snackBarHelper = useSnackBar();

  let history = useHistory();

  const onSubmit = async (data) => {
    if (loading !== null) {
      setLoading(true);
    }
    try {
      const res = await submitLogin(apiContext.axios, data);
      if (res) {
        authContext.login(res.data.id);
        snackBarHelper.openSnackBar('success', loginSuccMessage);
        setTimeout(() => {
          history.push('/status');
        }, 500);
      }
    } catch (e) {
      if (e.toString() === 'Error: Token not found') {
        snackBarHelper.openSnackBar('warning', tokenNotFoundMessage);
      } else {
        snackBarHelper.openSnackBar('error', e.toString());
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxWidth="xs">
      <form
        className={formclasses.formCommons}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Box>
          {loginData.map((data, i) => (
            <InputField
              key={data.attr + String(i)}
              type={data.type}
              attr={data.attr}
              rules={data.rules}
              register={register}
              error={errors[data.attr]}
            />
          ))}
          <Button type="submit" variant="contained" color="primary">
            {submitMessage}
          </Button>
        </Box>
      </form>
    </Box>
  );
}
